import { Button } from "@mui/material"
import UseFocusFirstInvalidField from "common/UseFocusFirstInvalidField"
import { trackCheckoutStep } from "common/analytics"
import { Field, Form, Formik, FormikProps } from "formik"
import { TextField } from "formik-mui"
import { useEffect, useMemo, useRef } from "react"
import routes from "routes"
import { useAppDispatch, useTypedSelector } from "store"
import styled from "styled-components"
import * as yup from "yup"
import { generateVerificationCode } from "../authSlice"

const StyledButton = styled(Button)<{ $hasContent?: boolean }>`
  margin-top: ${(p) => p.theme.spacing(1)}px;
  background: ${(p) => (p.$hasContent ? "black" : p?.theme?.colors?.darkGrey)};

  height: 45px;
  border-radius: 3px;
  border: none;
  color: ${(p) => (p.$hasContent ? "#fffff" : "#101010")};
  font-weight: 400;
  line-height: 140%;
  border-radius: 4px;
  letter-spacing: 0.05em;

  &:hover {
    background: ${(p) => p.theme.colors.steel};
    color: ${(p) => p.theme.colors.white};
    border: none;
  }

  &:active,
  :focus {
    background: black;
    color: white;
    border: none;
  }

  &:disabled {
    background: black;
    outline: none;
    border: none;
    border-radius: 3px;
  }
`

const StyledField = styled(Field)`
  > * input {
    direction: rtl !important;
    ::placeholder,
    ::-webkit-input-placeholder {
      color: rgba(97, 97, 97, 1);
      opacity: 1;
    }
  }
`

const schema = yup
  .object({
    phone: yup
      .string()
      .required("יש להזין מספר נייד")
      .matches(/^05\d?\d{7}$/, "מספר נייד שגוי"),
  })
  .defined()

const initialValues: yup.InferType<typeof schema> = { phone: "" }

const PhoneForm = () => {
  const { loading, temporaryPhone } = useTypedSelector((state) => state.auth)
  const dispatch = useAppDispatch()
  const bagRef = useRef<FormikProps<typeof initialValues>>()
  const phoneRef = useRef<HTMLInputElement>(null)
  const fieldNameInputRefMap = useMemo(() => ({ phone: phoneRef }), [])

  useEffect(() => {
    if (temporaryPhone) bagRef.current?.setFieldValue("phone", temporaryPhone)
  }, [temporaryPhone])

  useEffect(() => {
    if (location.hash === `#${routes.summary.path}`) trackCheckoutStep("2")
  }, [])

  return (
    <Formik
      validationSchema={schema}
      initialValues={initialValues}
      onSubmit={async (values) => {
        await dispatch(generateVerificationCode(values.phone))
      }}
      innerRef={bagRef as any}
    >
      {(props) => (
        <>
          <UseFocusFirstInvalidField
            fieldNameInputRefMap={fieldNameInputRefMap}
          />

          <Form noValidate>
            <StyledField
              name="phone"
              id="phone"
              component={TextField}
              type="tel"
              required
              autoComplete="tel-national"
              helperText=" " // prevent a "jump" when an error appears
              inputProps={{ maxLength: 11, style: { direction: "ltr" } }}
              inputRef={phoneRef}
              placeholder="טלפון נייד*"
              onChange={(e) => {
                props.handleChange(e)
              }}
            />

            {/* TODO: Use LoadingButton */}
            <StyledButton
              fullWidth
              variant="contained"
              color="primary"
              type="submit"
              disabled={loading}
              $hasContent={!!props?.values?.phone}
            >
              שלחו לי קוד זיהוי בסמס
            </StyledButton>
          </Form>
        </>
      )}
    </Formik>
  )
}

export default PhoneForm
